export * from './pagination.module';
export * from './pagination.component';


// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/layout/pagination/index.ts